<template>
    <rkm-modal
        extra-large
        ref="Modal"
        title="Agendamento"
    >
        <Form
            :id="pacienteId"
            :hasPrint="hasPrint"
            :hasAmbulatorio="hasAmbulatorio"
            :hide-agendamentos="hideAgendamentos"
            :regulacao-solicitacao="regulacaoSolicitacao"
            :reagendar="reagendar"
            @handleAtualizaPaciente="handleAtualizaPaciente"
            @handleExitPaciente="close"
            @save="handleSave"
            class="form"
            ref="Form"
        />

        <template v-slot:footer="{ cancel }">
            <rkm-button
                :disabled="!!loading"
                @click="cancel"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="$refs.Form.save()"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

// Vuex.
import { mapGetters } from 'vuex'

export default {
    components: { Form },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    methods: {
        open() {

            this.$refs.Modal.show()
        },
        handleAtualizaPaciente() {

            this.$router.push({ name: 'cadastro-paciente-edit', params: { id: this.pacienteId } })
        },
        handleSave(data) {

            this.$emit('save', data)
            this.close()
        },
        close() {

            this.$refs.Modal.hide()
        },
    },
    props: {
        pacienteId: { type: Number, required: true },
        hideAgendamentos: { type: Boolean, default: false },
        hasPrint: { type: Boolean, default: false },
        hasAmbulatorio: { type: Boolean, default: false },
        regulacaoSolicitacao: { type: Object },
        reagendar: { type: Object },
    }
}
</script>

<style scoped>
.form >>> .custom-calendar {
    width: 525px !important;
}
</style>